import type { IconNode } from '../types';

/**
 * @name snowboard
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgNmE0IDQgMCAwIDAtNy4yLTIuM2MtNC4yIDUuOC01LjMgNi45LTExLjEgMTEuMWE0IDQgMCAxIDAgNS41IDUuNWM0LjItNS44IDUuMy02LjkgMTEuMS0xMS4xIDEtLjcgMS43LTEuOSAxLjctMy4yIiAvPgogIDxwYXRoIGQ9Ik02LjE1IDEzSDExdjQuODUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/snowboard
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const snowboard: IconNode = [
  [
    'path',
    {
      d: 'M22 6a4 4 0 0 0-7.2-2.3c-4.2 5.8-5.3 6.9-11.1 11.1a4 4 0 1 0 5.5 5.5c4.2-5.8 5.3-6.9 11.1-11.1 1-.7 1.7-1.9 1.7-3.2',
      key: 'ftl77s',
    },
  ],
  ['path', { d: 'M6.15 13H11v4.85', key: 'virgxs' }],
];

export default snowboard;
